<template>
	<div class="popup popup--least" @mousedown.self="closePopup">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Вход в систему</div>
				<div class="popup__close" @click="closePopup" :title="thisLoginPage ? 'Вернуться назад' : 'Закрыть'"></div>
			</div>
			<div class="popup__description">Для входа в систему введите логин и пароль, выданные менеджером компании «Находка»</div>
			<hr/>
			<div class="popup__content">
				<form class="popup__form">
					<div class="form__inputs">
						<InputText :label="'Логин'" :placeholder="'Введите логин'" v-model="formData.login" :errors="v$.formData.login.$errors"/>
					</div>
					<div class="form__inputs">
						<InputText :label="'Пароль'" :placeholder="'Введите пароль'" :password="true" v-model="formData.password" :errors="v$.formData.password.$errors"/>
					</div>
					<InputCheckbox :label="'Запомнить пароль'" v-model="formData.remember"/>
					<hr/>
					<div class="form__submit">
						<button class="form__submit-btn btn btn--color"  type="submit" @click.prevent="checkReCaptcha">Войти</button>
						<div class="form__submit-action" @click="ShowResetPasswordPopup = true">Забыли пароль?</div>
					</div>
				</form>
			</div>
		</div>
		<transition name="modal">
			<ResetPasswordPopup v-if="ShowResetPasswordPopup" @close="ShowResetPasswordPopup = false" />
		</transition>
		<PageLoader v-if="isLoading"/>
	</div>

</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputCheckbox from "@/components/base/utils/formElements/InputCheckbox.vue";
import ResetPasswordPopup from "@/components/forms/ResetPasswordPopup.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email} from '@vuelidate/validators'
import { useToast } from "vue-toastification";
import {mapActions, mapGetters} from "vuex";

const {withMessage} = helpers

export default {
	name: "AuthLoginPopup",
	components: {InputText,InputCheckbox,ResetPasswordPopup, PageLoader},
	props: {
		thisLoginPage: {
			type: Boolean,
			default: false
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			ShowResetPasswordPopup: false,
			toast: useToast(),
			formData: {
				login: '',
				password: '',
				remember: false,
				token: ''
			}
		}
	},

	methods: {
		async checkReCaptcha() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}

			// eslint-disable-next-line no-undef
			await grecaptcha.ready(() => {
				// eslint-disable-next-line no-undef
				grecaptcha.execute('6Le-0jsmAAAAANJNzqizBZv0AZCkt7xN3OkDdRCR', {action: 'submit'}).then(async (token) => {
					this.formData.token = token
					await this.sendForm()
				});
			});
		},

		async sendForm() {
			console.log(this.formData)
			let response = await this.requestUserAuth(this.formData)
			if(response.success) {
				window.location.href = '/personal/'
			} else {
				this.toast.error(response.message);
			}
		},
		closePopup() {
			!this.thisLoginPage ? this.$emit('close') : window.location.href = '/'
		},
        ...mapActions({
            requestUserAuth: 'user/requestUserAuth',
        }),
	},
	computed: {
		...mapGetters({
			isLoading: 'isLoading',
		})
	},

	validations() {
		return {
			formData: {
				login: {
					email: this.formData.login != 'xpage' ? withMessage('Неверный формат электронной почты', email) : true,
					required: withMessage('Заполните E-mail', required),
				},
				password: {
					required: withMessage("Заполните пароль", required),
				},
			}
		}
	},

}
</script>


